import { getQueryString } from 'utility/helpers';
import { globalEndpoints } from './global';

export const physicianEndpoints = {
  getPhysician: (physicianIdEncrypted) => `${globalEndpoints.apiUrl}/Physician/${physicianIdEncrypted}`,
  getPhysicianProfile: () => `${globalEndpoints.apiUrl}/Physician/MyProfile`,
  saveMyEmail: () => `${globalEndpoints.apiUrl}/Physician/MyEmail`,
  getMyPatientsList: (options) => {
    const queryString = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');

    return `${globalEndpoints.apiUrl}/Physician/MyPatients?${queryString}`;
  },
  deletePhysicianSuspension: () => `${globalEndpoints.apiUrl}/physician/DeletePhysicianSuspension`,
  addPhysicianSuspension: () => `${globalEndpoints.apiUrl}/physician/AddPhysicianSuspension`,
  getPatientCertificationDocumentation: (queryString, options) => {
    const ops = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');

    return `${globalEndpoints.apiUrl}/CertificationDocumentation/physician/patient${queryString}&${ops}`;
  },
  getCertificationDocumentation: (queryString, options) => {
    const ops = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');
    return `${globalEndpoints.apiUrl}/CertificationDocumentation/physician/type${queryString}&${ops}`;
  },
  certificationDocumentationUpload: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/Upload`,
  certificationDocumentationDownload: (certificationUploadId) => `${globalEndpoints.apiUrl}/CertificationDocumentation/Download?CertificationUploadsId=${certificationUploadId}`,
  certificationDocumentationDelete: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/Delete`,
  getArfCertDoc: (CertificationDocumentationIdEncrypted) => `${globalEndpoints.apiUrl}/CertificationDocumentation/${CertificationDocumentationIdEncrypted}/arf`,
  saveArfCertDoc: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/SaveArf`,
  getSkcCertDoc: (CertificationDocumentationIdEncrypted) => `${globalEndpoints.apiUrl}/CertificationDocumentation/${CertificationDocumentationIdEncrypted}/skc`,
  saveSkcCertDoc: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/SaveSkc`,
  getSpcCertDoc: (CertificationDocumentationIdEncrypted) => `${globalEndpoints.apiUrl}/CertificationDocumentation/${CertificationDocumentationIdEncrypted}/spc`,
  saveSpcCertDoc: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/SaveSpc`,
  getCmpCertDoc: (CertificationDocumentationIdEncrypted) => `${globalEndpoints.apiUrl}/CertificationDocumentation/${CertificationDocumentationIdEncrypted}/cmp`,
  saveCmpCertDoc: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/SaveCmp`,
  getRfeCertDoc: (CertificationDocumentationIdEncrypted) => `${globalEndpoints.apiUrl}/CertificationDocumentation/${CertificationDocumentationIdEncrypted}/rfe`,
  saveRfeCertDoc: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/SaveRfe`,
  findCardholderHsmv: (options) => {
    const queryString = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');

    return `${globalEndpoints.apiUrl}/Physician/FindNewPerson?${queryString}`;
  },
  activatePatient: (patientIdEncrypted) => `${globalEndpoints.apiUrl}/Patient/${patientIdEncrypted}/Activate`,
  deactivatePatient: (patientIdEncrypted) => `${globalEndpoints.apiUrl}/Patient/${patientIdEncrypted}/Deactivate`,
  checkMqaRegistration: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Physician/RegistrationCheck?${queryString}`;
  },
  checkMqaStatus: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Physician/StatusCheck?${queryString}`;
  },
  unclosedCertifications: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Physician/UnclosedCertifications?${queryString}`;
  },
  getAdverseEvent: (certificationIdEncrypted, options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Certification/${certificationIdEncrypted}/adverseEvents?${queryString}`;
  },
  getControlledSubstances: (certificationIdEncrypted, options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Certification/${certificationIdEncrypted}/controlledSubstances?${queryString}`;
  },
  addNewAdverseEvent: () => `${globalEndpoints.apiUrl}/Certification/NewAdverseEvent`,
  updateAdverseEvent: () => `${globalEndpoints.apiUrl}/Certification/UpdateAdverseEvent`,
  addNewControlledSubstance: () => `${globalEndpoints.apiUrl}/Certification/NewControlledSubstance`,
  updateControlledSubstance: () => `${globalEndpoints.apiUrl}/Certification/UpdateControlledSubstance`,
  removeAdverseEvent: (encryptedAdverseEventId) => `${globalEndpoints.apiUrl}/Certification/DeleteAdverseEvent/${encryptedAdverseEventId}`,
  removeControlledSubstance: (encryptedControlledSubstanceId) => `${globalEndpoints.apiUrl}/Certification/DeleteControlledSubstance/${encryptedControlledSubstanceId}`,
  closeCertification: () => `${globalEndpoints.apiUrl}/Certification/CloseCertification`,
  getAssignedCaregivers: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Physician/GetPatientCaregivers?${queryString}`;
  },
  removeCaregiver: () => `${globalEndpoints.apiUrl}/Physician/RemovePatientCaregiver`,
  findNewCaregiver: (options) => {
    const queryString = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');

    return `${globalEndpoints.apiUrl}/Physician/FindNewCaregiver?${queryString}`;
  },
  associateCaregiverToPatient: () => `${globalEndpoints.apiUrl}/Physician/AssociateExistingCaregiverToPatient`,
  getAssignedPatients: (options) => {
    const queryString = getQueryString(options);
    return `${globalEndpoints.apiUrl}/Physician/GetCaregiverPatients?${queryString}`;
  },
  getDashboardCertDocCounts: () => {
    return `${globalEndpoints.apiUrl}/Physician/GetCertDocCountsForDashboard`;
  },
  getDashboardCertCounts: () => {
    return `${globalEndpoints.apiUrl}/Physician/GetCertificationsForDashboard`;
  },
  getDashboardRecentLogins: () => {
    return `${globalEndpoints.apiUrl}/Physician/GetRecentLoginsForDashboard`;
  },
  getDashboardRecentlyViewedPatients: () => {
    return `${globalEndpoints.apiUrl}/Physician/GetRecentlyViewedPatientsForDashboard`;
  }
};
